import React from "react";
import { KTSVG } from "../../../../../_metronic/helpers";
import { useIntl } from "react-intl";
import { startCase } from "lodash";
import { ActionButton } from "src/app/components";

export type SimpleEntityGridActionCellButton =
    | "edit"
    | "silo"
    | "disable"
    | "enable"
    | "sendText"
    | "viewText"
    | "chooseRD"
    | "wordpressAccess"
    | "waiting"
    | "addUrl"
    | "disableWithConfirmation"
    | "verified"
    | "createPopcashCampaign"
    | "approve"
    | "orderText"
    | "removeRD"
    | "indexMe"
    | "addAITitleAndPlan"
    | "addAITitle"
    | "addAIPlan"
    | "netlinking"
    | "plannings"
    | "AIGuide"
    | "createCampaign"
    | "editPersona"
    | "";

export type TActionsConditions = {
    edit?(data: any): boolean;
    disable?(data: any): boolean;
    enable?(data: any): boolean;
    sendText?(data: any): boolean;
    netlinking?(data: any): boolean;
    silo?(data: any): boolean;
    createPopcashCampaign?(data: any): boolean;
    viewText?(data: any): boolean;
    chooseRD?(data: any): boolean;
    waiting?(data: any): boolean;
    addUrl?(data: any): boolean;
    removeRD?(data: any): boolean;
    disableWithConfirmation?(data: any): boolean;
    verified?(data: any): boolean;
    approve?(data: any): boolean;
    orderText?(data: any): boolean;
    indexMe?(data: any): boolean;
    plannings?(data: any): boolean;
    wordpressAccess?(data: any): boolean;
    addAITitleAndPlan?(data: any): boolean;
    addAITitle?(data: any): boolean;
    addAIPlan?(data: any): boolean;
    AIGuide?(data: any): boolean;
    editPersona?(data: any): boolean;
    createCampaign?(data: any): boolean;
};

export type SimpleEntityGridActionCellProps = {
    data: any;
    onClick: (action: SimpleEntityGridActionCellButton) => void;
    actions: SimpleEntityGridActionCellButton[];
    actionsConditions?: TActionsConditions;
    actionsDisableConditions?: TActionsConditions;
};

export const SimpleEntityGridActionCell: React.FC<SimpleEntityGridActionCellProps> = (props) => {
    const { onClick, data, actions, actionsConditions, actionsDisableConditions } = props;

    const { formatMessage } = useIntl();

    if (data?.active)
        return (
            <>
                <ActionButton
                    actions={actions}
                    name="silo"
                    actionsCondition={actionsConditions?.silo}
                    data={data}
                    disable={actionsDisableConditions?.silo}
                >
                    <a
                        onClick={() => onClick("silo")}
                        title={startCase(formatMessage({ id: "common.action.silo" }))}
                        className="inline-action"
                    >
                        <KTSVG
                            path="/media/icons/duotune/coding/cod002.svg"
                            className="svg-icon-2"
                        />
                    </a>
                </ActionButton>

                <ActionButton
                    actions={actions}
                    name="netlinking"
                    actionsCondition={actionsConditions?.netlinking}
                    data={data}
                    disable={actionsDisableConditions?.netlinking}
                >
                    <a
                        onClick={() => onClick("netlinking")}
                        title={startCase(formatMessage({ id: "common.action.netlinking" }))}
                        className="inline-action"
                    >
                        <KTSVG
                            path="/media/icons/duotune/files/fil022.svg"
                            className="svg-icon-2"
                        />
                    </a>
                </ActionButton>

                <ActionButton
                    actions={actions}
                    name="wordpressAccess"
                    actionsCondition={actionsConditions?.wordpressAccess}
                    data={data}
                    disable={actionsDisableConditions?.wordpressAccess}
                >
                    <a
                        onClick={() => onClick("wordpressAccess")}
                        title={startCase(formatMessage({ id: "common.action.wordpressAccess" }))}
                        className="inline-action"
                    >
                        <KTSVG
                            path="/media/icons/duotune/coding/cod008.svg"
                            className="svg-icon-2"
                        />
                    </a>
                </ActionButton>

                <ActionButton
                    actions={actions}
                    name="plannings"
                    actionsCondition={actionsConditions?.plannings}
                    data={data}
                    disable={actionsDisableConditions?.plannings}
                >
                    <a
                        onClick={() => onClick("plannings")}
                        title={startCase(formatMessage({ id: "common.action.plannings" }))}
                        className="inline-action"
                    >
                        <KTSVG
                            path="/media/icons/duotune/coding/cod002.svg"
                            className="svg-icon-2"
                        />
                    </a>
                </ActionButton>
                <ActionButton
                    actions={actions}
                    name="indexMe"
                    actionsCondition={actionsConditions?.indexMe}
                    data={data}
                    disable={actionsDisableConditions?.indexMe}
                >
                    <a
                        onClick={() => onClick("indexMe")}
                        title={startCase(formatMessage({ id: "common.action.indexMe" }))}
                        className="inline-action"
                    >
                        <KTSVG
                            path="/media/icons/duotune/communication/com008.svg"
                            className="svg-icon-2"
                        />
                    </a>
                </ActionButton>
                <ActionButton
                    actions={actions}
                    name="sendText"
                    actionsCondition={actionsConditions?.sendText}
                    data={data}
                    disable={actionsDisableConditions?.sendText}
                >
                    <a
                        onClick={() => onClick("sendText")}
                        title={startCase(formatMessage({ id: "common.action.sendText" }))}
                        className="inline-action"
                    >
                        <KTSVG path="/media/icons/duotune/text/txt001.svg" className="svg-icon-2" />
                    </a>
                </ActionButton>
                <ActionButton
                    actions={actions}
                    name="verified"
                    actionsCondition={actionsConditions?.verified}
                    disable={actionsDisableConditions?.verified}
                    data={data}
                >
                    <a
                        onClick={() => onClick("verified")}
                        title={startCase(formatMessage({ id: "common.action.verified" }))}
                        className="inline-action"
                    >
                        <KTSVG
                            path="/media/icons/duotune/arrows/arr084.svg"
                            className="svg-icon-2"
                        />
                    </a>
                </ActionButton>

                <ActionButton
                    actions={actions}
                    name="viewText"
                    actionsCondition={actionsConditions?.viewText}
                    disable={actionsDisableConditions?.viewText}
                    data={data}
                >
                    <a
                        onClick={() => onClick("viewText")}
                        title={startCase(formatMessage({ id: "common.action.viewText" }))}
                        className="inline-action"
                    >
                        <KTSVG
                            path="/media/icons/duotune/files/fil003.svg"
                            className="svg-icon-2"
                        />
                    </a>
                </ActionButton>

                <ActionButton
                    actions={actions}
                    name="waiting"
                    actionsCondition={actionsConditions?.waiting}
                    disable={actionsDisableConditions?.waiting}
                    data={data}
                >
                    <a
                        onClick={() => onClick("waiting")}
                        title={startCase(formatMessage({ id: "common.action.waiting" }))}
                        className="inline-action"
                    >
                        <KTSVG
                            path="/media/icons/duotune/files/fil011.svg"
                            className="svg-icon-2"
                        />
                    </a>
                </ActionButton>
                <ActionButton
                    actions={actions}
                    name="removeRD"
                    actionsCondition={actionsConditions?.removeRD}
                    disable={actionsDisableConditions?.removeRD}
                    data={data}
                >
                    <a
                        onClick={() => onClick("removeRD")}
                        title={startCase(formatMessage({ id: "common.action.removeRD" }))}
                        className="inline-action"
                    >
                        <KTSVG
                            path="/media/icons/duotune/coding/cod008.svg"
                            className="svg-icon-2"
                        />
                    </a>
                </ActionButton>
                <ActionButton
                    actions={actions}
                    name="orderText"
                    actionsCondition={actionsConditions?.orderText}
                    disable={actionsDisableConditions?.orderText}
                    data={data}
                >
                    <a
                        onClick={() => onClick("orderText")}
                        title={startCase(formatMessage({ id: "common.action.orderText" }))}
                        className="inline-action"
                    >
                        <KTSVG
                            path="/media/icons/duotune/ecommerce/ecm006.svg"
                            className="svg-icon-2"
                        />
                    </a>
                </ActionButton>

                <ActionButton
                    actions={actions}
                    name="addUrl"
                    actionsCondition={actionsConditions?.addUrl}
                    disable={actionsDisableConditions?.addUrl}
                    data={data}
                >
                    <a
                        onClick={() => onClick("addUrl")}
                        title={startCase(formatMessage({ id: "common.action.addUrl" }))}
                        className="inline-action"
                    >
                        <KTSVG
                            path="/media/icons/duotune/coding/cod007.svg"
                            className="svg-icon-2"
                        />
                    </a>
                </ActionButton>

                <ActionButton
                    actions={actions}
                    name="chooseRD"
                    actionsCondition={actionsConditions?.chooseRD}
                    disable={actionsDisableConditions?.chooseRD}
                    data={data}
                >
                    <a
                        onClick={() => onClick("chooseRD")}
                        title={startCase(formatMessage({ id: "common.action.chooseRD" }))}
                        className="inline-action"
                    >
                        <KTSVG
                            path="/media/icons/duotune/coding/cod007.svg"
                            className="svg-icon-2"
                        />
                    </a>
                </ActionButton>

                <ActionButton
                    actions={actions}
                    name="approve"
                    actionsCondition={actionsConditions?.approve}
                    disable={actionsDisableConditions?.approve}
                    data={data}
                >
                    <a
                        onClick={() => onClick("approve")}
                        title={startCase(formatMessage({ id: "common.action.approve" }))}
                        className="inline-action"
                    >
                        <KTSVG
                            path="/media/icons/duotune/general/gen063.svg"
                            className="svg-icon-2"
                        />
                    </a>
                </ActionButton>

                <ActionButton
                    actions={actions}
                    name="addAITitle"
                    actionsCondition={actionsConditions?.addAITitle}
                    data={data}
                    disable={actionsDisableConditions?.addAITitle}
                >
                    <a
                        onClick={() => onClick("addAITitle")}
                        title={startCase(formatMessage({ id: "common.action.addAITitle" }))}
                        className="inline-action text-primary"
                    >
                        {startCase(formatMessage({ id: "common.action.addAITitle" }))}
                    </a>
                </ActionButton>
                <ActionButton
                    actions={actions}
                    name="addAIPlan"
                    actionsCondition={actionsConditions?.addAIPlan}
                    data={data}
                    disable={actionsDisableConditions?.addAIPlan}
                >
                    <a
                        onClick={() => onClick("addAIPlan")}
                        title={startCase(formatMessage({ id: "common.action.addAIPlan" }))}
                        className="inline-action text-primary"
                    >
                        {startCase(formatMessage({ id: "common.action.addAIPlan" }))}
                    </a>
                </ActionButton>
                <ActionButton
                    actions={actions}
                    name="addAITitleAndPlan"
                    actionsCondition={actionsConditions?.addAITitleAndPlan}
                    data={data}
                    disable={actionsDisableConditions?.addAITitleAndPlan}
                >
                    <a
                        onClick={() => onClick("addAITitleAndPlan")}
                        title={startCase(formatMessage({ id: "common.action.addAITitleAndPlan" }))}
                        className="inline-action"
                    >
                        <KTSVG
                            path="/media/icons/duotune/technology/teh003.svg"
                            className="svg-icon-2"
                        />
                    </a>
                </ActionButton>

                <ActionButton
                    actions={actions}
                    name="AIGuide"
                    actionsCondition={actionsConditions?.AIGuide}
                    data={data}
                    disable={actionsDisableConditions?.AIGuide}
                >
                    <a
                        onClick={() => onClick("AIGuide")}
                        title={startCase(formatMessage({ id: "common.action.AIGuide" }))}
                        className="inline-action"
                    >
                        <KTSVG
                            path="/media/icons/duotune/general/gen062.svg"
                            className="svg-icon-2"
                        />
                    </a>
                </ActionButton>
                <ActionButton
                    actions={actions}
                    name="createCampaign"
                    actionsCondition={actionsConditions?.createCampaign}
                    data={data}
                    disable={actionsDisableConditions?.createCampaign}
                >
                    <a
                        onClick={() => onClick("createCampaign")}
                        title={startCase(formatMessage({ id: "common.action.createCampaign" }))}
                        className="inline-action"
                    >
                        <KTSVG
                            path="/media/icons/duotune/general/gen002.svg"
                            className="svg-icon-2"
                        />
                    </a>
                </ActionButton>
                <ActionButton
                    actions={actions}
                    name="createPopcashCampaign"
                    actionsCondition={actionsConditions?.createPopcashCampaign}
                    data={data}
                    disable={actionsDisableConditions?.createPopcashCampaign}
                >
                    <a
                        onClick={() => onClick("createPopcashCampaign")}
                        title={startCase(
                            formatMessage({ id: "common.action.createPopcashCampaign" })
                        )}
                        className="inline-action"
                    >
                        <KTSVG
                            path="/media/icons/duotune/general/gen016.svg"
                            className="svg-icon-2"
                        />
                    </a>
                </ActionButton>

                <ActionButton
                    actions={actions}
                    name="edit"
                    actionsCondition={actionsConditions?.edit}
                    data={data}
                    disable={actionsDisableConditions?.edit}
                >
                    <a
                        onClick={() => onClick("edit")}
                        title={startCase(formatMessage({ id: "common.action.edit" }))}
                        className="inline-action"
                    >
                        <KTSVG path="/media/icons/duotune/art/art005.svg" className="svg-icon-2" />
                    </a>
                </ActionButton>
                <ActionButton
                    actions={actions}
                    name="disable"
                    actionsCondition={actionsConditions?.disable}
                    data={data}
                    disable={actionsDisableConditions?.disable}
                >
                    <a
                        onClick={() => onClick("disable")}
                        title={startCase(formatMessage({ id: "common.action.disable" }))}
                        className="inline-action"
                    >
                        <KTSVG
                            path="/media/icons/duotune/arrows/arr015.svg"
                            className="svg-icon-2"
                        />
                    </a>
                </ActionButton>

                <ActionButton
                    actions={actions}
                    name="editPersona"
                    actionsCondition={actionsConditions?.editPersona}
                    data={data}
                    disable={actionsDisableConditions?.editPersona}
                >
                    <a
                        onClick={() => onClick("editPersona")}
                        title={startCase(formatMessage({ id: "common.action.editPersona" }))}
                        className="inline-action"
                    >
                        <KTSVG path="/media/icons/duotune/art/art005.svg" className="svg-icon-2" />
                    </a>
                </ActionButton>

                <ActionButton
                    actions={actions}
                    name="disableWithConfirmation"
                    actionsCondition={actionsConditions?.disableWithConfirmation}
                    data={data}
                    disable={actionsDisableConditions?.disableWithConfirmation}
                >
                    <a
                        onClick={() => onClick("disableWithConfirmation")}
                        title={startCase(formatMessage({ id: "common.action.disable" }))}
                        className="inline-action"
                    >
                        <KTSVG
                            path="/media/icons/duotune/arrows/arr015.svg"
                            className="svg-icon-2"
                        />
                    </a>
                </ActionButton>
            </>
        );

    return (
        <a
            onClick={() => onClick("enable")}
            title={startCase(formatMessage({ id: "common.action.enable" }))}
            className="inline-action"
        >
            <KTSVG path="/media/icons/duotune/arrows/arr013.svg" className="svg-icon-2" />
        </a>
    );
};
